/** 法律文档完整正文（与 docs/ 框架协议及附件同步，供前端兜底展示） */
export const LEGAL_DOCUMENT_FULL_CONTENT: Record<string, string> = {
  privacy_policy: `附件四：平台隐私政策与数据处理规则

制定主体：联采易（南京）科技有限公司
版本：V1.0    生效日期：______年______月______日
说明：本附件为《厂家入驻物业集采平台合作框架协议》的组成部分，与框架协议正文具有同等法律效力。

第一条  适用范围
本规则适用于联采易智物业集采平台对供应商、采购方及平台用户的个人信息与业务数据的处理活动。供应商入驻并使用平台，即表示已阅读并同意本规则。
第二条  我们收集的信息
2.1  供应商信息
企业信息：名称、统一社会信用代码、地址、经营范围、银行账户等。
联系人信息：姓名、手机号、邮箱、职务等。
资质信息：营业执照、授权书、许可证件、产品合格证明等。
交易信息：商品、订单、发货、收款确认、对账及售后记录。
2.2  采购方及平台用户信息
账号信息、组织信息、采购需求、订单及收货信息。
为完成交易所必需的联系与履约信息。
平台日志：访问时间、IP、设备信息、操作记录等。
第三条  信息使用目的
提供入驻审核、商品上架、订单撮合、对账结算等平台服务。
身份验证、安全风控、欺诈防范及纠纷处理。
向供应商展示与其相关的订单、履约及经营分析数据。
改进产品功能、优化用户体验及平台运营。
经脱敏处理后用于统计分析、行业研究（无法识别特定主体）。
遵守法律法规及监管要求。
第四条  信息共享与披露
为完成交易，平台向采购方展示供应商必要的企业及商品信息，向供应商展示订单履约必要信息。
未经合法授权，不向无关第三方出售个人信息。
以下情形除外：法律法规要求、司法机关或监管机构依法调取、经用户明确同意、为保护平台/用户合法权益所必需。
平台可委托云服务、短信、身份验证、短信验证等服务商处理必要信息，并要求其承担保密及安全义务。
第五条  数据归属与安全
平台运营数据、用户行为数据及聚合分析数据的知识产权归平台所有。
供应商提交的原始商品及交易数据，供应商对其内容享有合法权益；平台可为运营、对账、风控及合规目的依法使用。
平台采取访问控制、传输加密、备份恢复等合理安全措施。
发生数据安全事件时，平台将依法及时告知并采取补救措施。
第六条  供应商义务
仅通过平台授权接口访问与自身业务相关的数据，不得非法抓取、爬取或外泄。
对通过平台获知的采购方联系人、地址、需求等信息承担保密义务，不得用于绕开平台交易或无关营销。
妥善保管账号密码，发现泄露应立即通知平台。
涉及个人信息处理活动的，应遵守《个人信息保护法》等法律法规。
第七条  信息保存与删除
在实现处理目的所必需的期限内保存信息；法律法规另有规定的从其规定。
合作终止后，平台可按合规要求继续保存交易及财务记录。
供应商可申请更正、补充其企业信息；删除请求须在不影响交易合规、财务审计及争议处理的前提下处理。
第八条  用户权利
依法享有查询、更正、删除、撤回同意等权利。可通过平台客服或指定邮箱提出请求，平台将在法律规定期限内答复。
第九条  未成年人信息
本平台面向企业用户，不面向未成年人提供服务。如发现误收集未成年人信息，将依法及时删除。
第十条  规则更新与联系我们
平台可根据法律法规及业务变化更新本规则，并提前7日公示。如有疑问，可通过平台公示的客服渠道联系联采易（南京）科技有限公司。`,
  platform_disclaimer: `平台免责声明

制定主体：联采易（南京）科技有限公司
版本：V1.0
说明：本声明适用于联采易智物业集采平台全体注册用户，与角色专属协议（如供应商合作协议、物业采购方使用协议）相互独立。

第一条  平台法律地位
联采易智物业集采平台（以下简称“平台”）由联采易（南京）科技有限公司运营，向物业采购方、供应商及授权用户提供信息技术服务与交易撮合。
平台不是采购方与供应商之间买卖合同的参与方，不代理任何一方缔约、履约、收款、发货或开具货款发票。

第二条  信息展示与审核
平台展示的商品、价格、库存、资质、企业信息等内容，主要由供应商或相关用户提供并保证其真实性、合法性。
平台作形式审核或合理审查，不对上述信息的完全准确、完整、时效性作明示或默示担保。
“平台认证供应商”“源头厂家”等标识仅表示通过平台准入审核，不构成对产品质量、持续供货能力或无侵权的任何保证。

第三条  交易与资金
采购方货款由采购方按订单约定直接支付至供应商账户，平台不代收、代付、保管或冻结货款。
平台展示的付款凭证、收货状态等主要用于交易协同与流程管理，不对线下私下结算承担核对或担保义务。
因货款、发票、税率、退换货、物流、售后等引发的争议，由采购方与供应商依法自行解决；平台可提供沟通协助，但不因此成为买卖关系当事人。

第四条  技术服务与运营
平台提供的搜索、推荐、曝光、流量匹配、数据分析等均为技术服务，不保证订单量、转化率或特定经营结果。
因系统维护、升级、故障、网络异常、第三方服务中断等导致平台暂时无法访问或功能受限的，平台在合理范围内修复，不承担超出法律规定范围的责任。

第五条  用户账号与安全
用户应妥善保管账号、密码及验证码，对账号下的操作负责。
因用户自身原因、账号泄露、越权操作或未及时挂失导致的损失，由用户自行承担；平台在接到正式通知并采取合理措施后，对后续扩大损失不承担责任。

第六条  责任限制
在法律允许的最大范围内，平台对间接损失、附带损失、惩罚性赔偿、商誉损失、预期利润损失、业务中断损失等不承担责任，但法律明确规定不得排除或限制的责任除外。
平台因提供本平台服务向任一用户承担的全部赔偿责任，累计不超过该用户就争议事项已向平台实际支付的服务费用总额（如无则以前十二个月内向平台支付的服务费用总额为上限）。

第七条  声明更新与联系我们
平台可根据法律法规及业务变化更新本声明，并提前公示。继续使用平台服务的，视为接受更新后的声明。
如有疑问，请通过平台公示的客服渠道联系联采易（南京）科技有限公司。`,
  supplier_framework: `厂家入驻物业集采平台合作框架协议
（修订稿）

甲方：联采易（南京）科技有限公司
统一社会信用代码：__________________________
住所地：____________________________________
联系人：______________  电话：______________  邮箱：______________

乙方：____________________________________
统一社会信用代码：__________________________
住所地：____________________________________
联系人：______________  电话：______________  邮箱：______________

鉴于甲方依法运营“联采易智”物业集采平台（以下简称“平台”），乙方拟以厂家/供应商身份入驻平台，向物业采购方（以下简称“采购方”）供应商品。甲乙双方经平等协商，本着“资源共享、优势互补、服务赋能、共赢发展”的原则，就乙方入驻平台相关事宜，达成如下框架协议。本协议为框架性约定，具体操作规则以本协议正文及附件、平台公示规则为准。

第一条  定义与解释
“平台”：指由甲方开发、运营并提供技术服务的物业集采线上采购协同系统及相关配套功能。
“采购方”：指通过平台发起采购、下单的物业公司及其授权采购人员。
“订单”/“电子订货单”：指采购方通过平台下单并经系统确认后自动生成的电子交易凭证。
“技术服务费”：指乙方通过平台完成交易后，按本协议及平台审价结果应向甲方支付的平台服务费用，不包含乙方货款、运费及税费。
“确认收货”：指采购方在平台点击确认收货，或物流信息显示已签收且超过平台规则约定的自动确认期限。
“关联企业”：指与乙方存在下列关系之一的企业：（1）一方持有另一方50%以上股权；（2）同受同一实际控制人控制；（3）法定代表人或主要负责人为同一人。
“源头厂家”：指具备自主生产或品牌原厂授权的一级供应能力，并经甲方审核认定的供应商。
第二条  合作模式与定位
2.1  合作定位
甲方为乙方提供线上展示、品牌背书、交易撮合、订单协同、对账结算等技术与运营服务。乙方通过平台获得增量订单，双方共享增长红利。甲方仅提供居间撮合及线上运营服务，不参与产品生产、仓储、物流、质检及实际交付，不拥有货物所有权，不代收、代付、保管采购方货款。
2.2  收费原则
甲方收益为乙方通过平台成功完成交易后，按照本协议及平台审价确认的标准向甲方支付的技术服务费。双方实行“按月对账、次月结算技术服务费”的模式。本协议项下结算对象仅为技术服务费，不涉及采购方货款。
2.3  品类准入与配额管理
为维护平台生态与采购方利益，甲方实行品类准入与动态配额管理。原则上，同一细分品类（以平台类目编码及商品属性为准）的源头厂家数量不超过3家，但甲方有权基于市场需求、供应能力、服务质量、战略协同等因素调整配额。出现下列情形之一，甲方可增加或减少配额：（1）应急物资、独家授权、区域独家供应；（2）现有供应商履约严重不达标；（3）平台业务拓展或品类规则调整。具体以《平台入驻与类目管理规则》（附件一）为准。
第三条  入驻资质、商品上架与审核
3.1  入驻资质
乙方应向甲方提交真实、完整、有效的营业执照、开户信息、联系人信息、经营许可（如需）、品牌授权（如需）、产品质量合格证明及其他甲方要求的材料。乙方保证所提交材料真实有效；因材料虚假导致的一切损失及法律责任由乙方承担。
3.2  商品上架与双审机制
乙方商品须通过平台“价格审核”和“品质/信息审核”后方可上架销售。价格审核时，甲方按商品或规格设定平台服务费率，并据此计算商城展示售价；品质审核包括商品信息、图文、专业参数、资质信息等。乙方修改价格、规格、图文等信息导致审核条件变化的，商品重新进入待审并自动下架，直至再次审核通过。甲方有权对已上架商品进行重新审价或重新审质。
3.3  身份标识
甲方根据乙方资质审核结果，向采购方展示“平台认证供应商”或“源头厂家”等标识。该标识不构成甲方对产品质量、交付能力、持续供货的任何担保，仅表示乙方已通过平台准入审核。
第四条  服务赋能与双方权责
4.1  平台资源与流量匹配
甲方基于平台规则及算法，为乙方提供合理的流量匹配、信息推送及展示机会，但不保证曝光量、点击量、转化率或订单量。
4.2  运营与数据赋能
甲方可为乙方提供搜索权重、专区推荐、广告投放等运营支持，具体形式、频率及资源分配由双方根据合作情况及平台规则协商确定，或按平台统一规则执行。甲方为乙方提供与其经营相关的数据分析服务；乙方仅可通过平台授权的后台接口访问相关数据，不得非法抓取、复制、外泄或商业化利用平台数据。
4.3  交易撮合与平台角色
甲方提供电子订单、对账、沟通等数字化工具，提升交易效率。双方确认：甲方仅为信息撮合及技术服务方，不是买卖合同的参与方，不参与买卖双方定价、质量验收、物流配送及货款收付。发生交易纠纷时，甲方可基于平台规则及交易记录协调、调解或提出处理建议，但该等协调、调解不具有强制执行力，亦不构成对交易结果的担保。
4.4  乙方履约义务
价格合规：乙方应遵守平台报价体系，不得诱导采购方绕开平台交易（详见第九条）。
响应机制：乙方应建立客服机制，对平台订单、询价及投诉在48小时内响应并提出处理方案；售后事项在24小时内首次响应。
供应保障：乙方应保障供货稳定。预计缺货、延迟或停产，应至少提前7个工作日在平台提交预警及替代方案。
物流与交付：仓储、包装、运输、配送、装卸及运输途中货损货差、逾期交付等成本及风险由乙方承担。乙方发货后12小时内录入真实物流信息；支持快递及自送等方式，均须如实填写。
发票与税务：乙方应按订单向采购方依法开具发票，并确保税率、品目、金额准确。
质量与售后：乙方保证商品符合国家强制性标准及明示质量要求，并承担质保、退换货及售后责任。
第五条  交易、定价、结算与开票
5.1  订单效力与定价逻辑
（1）采购方通过平台下单并经系统确认后，自动生成的《电子订货单》视为买卖双方具有法律效力的电子合同，订单总价为双方履行合同的主要依据。
（2）定价机制：
平台展示商品售价（不含税）= 乙方产品不含税出厂价 + 甲方技术服务费（不含税）
最终订单销售价（含税）=（乙方产品不含税价 + 运费不含税价 + 甲方技术服务费不含税金额）×（1 + 适用税率）
适用税率：由乙方在平台上架商品时设定，并与其向采购方开票类型一致。
技术服务费：按平台审价时确认的服务费率计算，费率以平台系统记录及审价结果为准。
运费计税：按国家税法规定及乙方开票类型执行；为简化操作，可与产品适用税率保持一致。
价格构成：订单销售价（含税）为采购方支付总额，包含产品价值、运费、技术服务费及依法应承担的税费。
商业秘密：售价拆分明细（产品价、运费、技术服务费）属于甲乙双方商业秘密，除依法披露或双方同意外，不得向无关第三方披露。
5.2  货款支付（直付模式）
采购方应按电子订货单所示“订单销售价（含税）”向乙方指定对公账户支付全额货款，并通过平台上传付款凭证。乙方确认收款后，应在平台同步付款状态。本平台执行“款到发货”原则：乙方确认收到货款后，在48小时内完成发货（特殊品类另有约定的除外）。采购方直付乙方账户的行为，在法律上视为采购方对乙方的付款义务。
5.3  技术服务费结算
对账周期：每自然月为一个结算周期，以采购方确认收货为准统计已完成交易。
对账单生成：每自然月结束后5个工作日内，甲方生成《月度技术服务费结算对账单》并发送至乙方（平台站内信、电子邮件或其他约定方式）。
核对与异议：乙方应在收到对账单后5个工作日内核对；有异议的，应一次性书面说明理由并附证明材料。逾期未提出异议且无合理说明的，视为认可。
付款时间：乙方应于收到对账单后、当月20日前（遇节假日顺延），向甲方支付上一自然月应付技术服务费总额。
结算金额：甲方为小规模纳税人时，应付技术服务费 = 审价技术服务费合计 M（不含税），供应商付款金额与甲方开具的增值税普通发票金额一致，不再另加增值税。甲方按小规模征收率自行申报纳税。
甲方升级为一般纳税人后，可按专票价税合计结算，届时以平台通知及补充协议为准。
逾期责任：乙方逾期支付超过10日的，甲方有权下架商品、限制账户功能、暂停推荐、终止合作，并按每日万分之五计收逾期违约金；违约金总额不超过应付未付金额的30%。
5.4  发票开具规范
乙方对采购方：应在采购方确认收货后7个工作日内，向采购方开具与订单金额一致的合法发票。
甲方对乙方：应在收到乙方支付的技术服务费后7个工作日内，向乙方开具等额合法发票（小规模纳税人为增值税普通发票，一般纳税人可为增值税专用发票）。
因乙方税率设定错误、开票信息错误或发票不合规导致采购方无法抵扣或遭受处罚的，由乙方承担全部责任。
5.5  交付与风险转移
货物毁损、灭失风险由乙方或其委托物流方承担，直至货物到达采购方指定地点并经采购方签收。采购方在平台确认收货，或物流显示签收且超过平台规则自动确认期限的，视为乙方完成交付义务。
第六条  禁止绕开平台交易（跳单）
6.1  定义
“绕开平台交易”是指乙方利用通过平台获得的客户资源、交易信息、联系方式、采购需求或历史交易记录，通过平台以外渠道引导、促成或参与采购方与乙方（或其关联企业）直接交易，从而规避平台规则及技术服务费的行为。
6.2  禁止行为
以低于平台价格、额外赠品、私下返点等方式诱导绕开平台；
通过关联企业、员工个人或第三方中介完成本可通过平台完成的交易；
采购方主动提出线下交易时，乙方未拒绝或未在24小时内向平台报备。
6.3  例外情形
本协议生效前已存在且已向甲方报备的书面合同；
法律法规、招标文件或采购方内部制度要求必须线下直采或招标的情形；
因不可抗力或紧急抢修、应急保供且事后24小时内报备的情形。
6.4  违约处理
乙方发生绕开平台交易行为的，构成根本违约。甲方有权：（1）立即下架全部商品；（2）限制或终止平台账户功能；（3）解除本协议并列入黑名单；（4）要求乙方支付违约金。违约金按下列较高者计算，但最高不超过人民币50万元：（a）该笔绕开订单金额的20%；或（b）乙方近三个月已向甲方支付技术服务费总额的1倍。甲方另有实际损失的，可就超出违约金部分继续追偿（含调查费、律师费、诉讼费等）。
甲方有权通过平台系统记录、订单数据、采购方反馈等合法方式进行调查。乙方应配合提供必要说明材料。
特别说明：因采购方货款直付乙方，甲方不控制、不保管货款，故甲方无权冻结乙方货款账户；甲方对绕开平台行为的处理，限于平台权限范围内及依法主张技术服务费债权。
第七条  数据资产、个人信息与保密
7.1  数据归属与使用
平台系统运行过程中产生的用户行为数据、页面访问数据、聚合分析数据及平台运营数据，其知识产权归甲方所有。
乙方提交的商品信息、报价、订单履约数据，乙方对其原始内容享有合法权益；甲方有权为平台运营、对账、风控、分析及依法合规目的使用上述数据。
经脱敏处理后无法识别特定主体的统计数据，甲方可用于行业研究、产品优化及商业开发。
7.2  个人信息保护
双方应遵守《个人信息保护法》等法律法规。未经合法授权，不得非法收集、使用、披露采购方或平台用户个人信息。
7.3  保密义务
双方对合作中获知的商业秘密承担保密义务，包括但不限于：平台算法与运营策略、未公开价格体系、乙方成本与利润信息、订单拆分明细及客户资源信息。保密义务不因本协议终止而失效。
7.4  保密例外
信息已合法公开；
接收方在披露前已合法持有；
依据法律法规、司法机关或监管机构要求披露（法律允许范围内应及时通知对方）。
第八条  知识产权与合规
乙方保证其在平台上传的商品名称、图片、文字、商标、专利及宣传内容不侵犯第三方合法权益。如发生侵权投诉或行政、司法认定，甲方有权先行下架，乙方应承担全部法律责任及甲方因此遭受的损失。
乙方不得实施商业贿赂、围标串标、虚假宣传、以次充好等违法行为。违反国家法律法规、行业强制性标准或平台规则的，甲方有权立即终止合作。
第九条  协议期限、变更与退出
9.1  合作期限
本协议有效期2年，自双方签署盖章之日起生效。期满前30日，任何一方未书面提出不续约通知的，自动顺延1年，以后亦同。
9.2  规则变更
甲方有权根据业务需要调整平台规则，但涉及乙方核心权利义务的重大变更，应提前7日在平台公示。乙方继续使用平台服务的，视为接受变更；不同意变更的，可申请终止合作。
9.3  退出与解除
任一方拟终止合作的，应提前30日书面通知对方。乙方有下列情形之一，甲方有权单方解除协议且不承担赔偿责任：
逾期支付技术服务费超过10日；
绕开平台交易；
重大质量事故、大面积缺货或严重损害平台声誉；
资质虚假或严重违法违规；
违反保密或数据合规义务。
9.4  终止后清算
协议终止不影响终止前已产生权利义务。终止前已确认订单，乙方仍须完成交付、开票、售后及技术服务费支付义务。协议终止不免除乙方对已售商品的质保及赔偿责任。
第十条  免责条款与责任限制
本章约定旨在明确平台作为信息技术服务与交易撮合方的法律边界。本章条款在协议终止或解除后继续有效。
10.1  不可抗力
因不能预见、不能避免且不能克服的客观情况导致不能履行或迟延履行本协议义务的，不构成违约。包括但不限于：自然灾害、战争、动乱、罢工、疫情、政府命令、法律法规或监管政策变化、征收、禁令、全国性或区域性电信/电力/网络中断、重大黑客攻击（甲方已履行合理安全防护义务的情形下）。
受影响方应在7日内书面通知对方，并在合理期限内提供证明。双方应根据影响程度协商延期履行、部分履行或解除协议，并尽力减少损失。因不可抗力导致平台服务中断、订单延迟处理或数据暂时无法访问的，甲方不承担违约责任。
10.2  平台法律地位与撮合免责
甲方仅提供平台技术、信息展示、交易撮合及配套运营服务，不是采购方与乙方之间买卖合同的当事人，不代理任何一方缔约或履约。
甲方不保证乙方必然获得订单、曝光量、点击量、转化率或特定经营结果。
甲方基于平台规则提供的流量匹配、推荐排序、搜索展示等，仅为技术服务，不构成对交易成功或收益水平的承诺。
甲方依据平台规则进行的协调、调解或处理建议，不具有行政或司法强制力，不构成对争议结果、产品质量或履约情况的担保。
10.3  商品信息、资质与审核免责
平台展示的商品名称、规格、图片、参数、价格、库存、资质文件等信息，主要由乙方提供并保证其真实性、合法性；甲方仅作形式审核或合理审查，不对上述信息的完全准确、完整、时效性作出担保。
甲方对乙方进行的“平台认证供应商”“源头厂家”等标识，仅表明其通过平台准入审核，不构成对产品质量、持续供货能力、无侵权或无违法违规的任何明示或默示保证。
除甲方明知乙方资质造假、虚构授权或故意协助其发布违法信息的情形外，因乙方信息虚假、过期、侵权或违规引发的纠纷，由乙方自行承担。
甲方依法收到投诉、通知或监管要求后，有权采取下架、限制展示、暂停审核等措施，该等措施本身不构成甲方对投诉内容的预先认定，亦不免除乙方自身责任。
10.4  交易、资金、发票与对账免责
采购方货款由采购方直接支付至乙方账户，甲方不代收、代付、保管、划转或冻结货款，不对乙方是否实际收到货款、收到金额是否准确、乙方是否依法使用货款承担担保或连带责任。
采购方上传的付款凭证、乙方确认的收款状态，主要供平台交易协同与流程管理使用；甲方不对付款凭证真实性、完整性作实质性审查或保证。
发票由乙方按法律规定向采购方开具，技术服务费发票由甲方向乙方开具；因税率适用、开票类型、品目编码、红冲重开等税务问题产生的争议，由开票义务方依法承担，甲方仅对自身开票行为负责。
月度对账单、订单记录、系统日志等由平台系统生成，作为双方结算参考依据；如存在明显系统错误或重复记录，任一方可在异议期内提出更正，但甲方不对采购方与乙方之间的线下私下结算承担核对义务。
10.5  物流、交付与售后免责
货物运输、配送、装卸、签收、货损货差、逾期交付、安装调试及售后维修，由乙方与采购方依法约定并自行处理，甲方不参与上述环节。
乙方录入的物流信息（含快递、自送等方式）由乙方负责真实性；因虚假物流、延迟录入或第三方物流原因造成的损失，由乙方或相关责任方承担。
退换货、质量异议、维修、赔偿等售后事项，由乙方作为销售方依法向采购方承担；甲方可提供沟通协助，但不因此成为售后责任主体。
10.6  技术与第三方服务免责
因系统维护、升级、测试、故障、兼容性问题、网络拥堵、云服务或第三方接口异常导致平台暂时无法访问、功能受限、消息延迟或数据展示错误的，甲方不承担违约责任，但应在合理范围内修复。
甲方对平台依法采取的网络安全、数据备份、访问控制等措施，不构成对绝对安全、绝对无中断或无差错的保证。
因电信运营商、银行、物流平台、短信/邮件服务商等第三方原因导致的服务异常，由第三方或相应合同相对方依法承担，甲方在已尽合理选型和管理义务后不承担责任。
甲方提供的行业趋势、经营分析、参考价格、竞品动态等数据报表，仅供乙方经营参考，不构成投资建议或必然商业结论。
10.7  采购方行为与账号安全免责
因采购方取消订单、拒绝收货、迟延付款、错误下单、错误收货信息、内部审批变化等采购方原因导致的损失，由采购方与乙方自行解决，甲方不承担责任。
乙方应妥善保管平台账号、密码、验证码及操作权限。因乙方自身原因、员工/代理人越权操作、账号泄露或未及时挂失导致的损失，由乙方自行承担；甲方在接到乙方正式通知并采取合理措施后，对后续扩大损失不承担责任。
10.8  间接损失排除
在任何情况下，任何一方均不对另一方承担间接损失、附带损失、惩罚性赔偿、商誉损失、预期利润损失、业务中断损失、数据丢失导致的间接损失或其他不可预见的损失，即使该损失在订立本协议时可被预见，但法律明确规定不得排除或限制的责任除外。
10.9  责任上限
在法律允许的最大范围内，甲方因本协议（包括违约、侵权或其他原因）向乙方承担的全部赔偿责任，累计不超过争议发生前12个月内乙方实际向甲方支付的技术服务费总额。
上述责任上限不适用于下列情形：（1）甲方故意或重大过失；（2）甲方侵犯乙方知识产权；（3）甲方违反个人信息保护义务导致乙方遭受直接损失；（4）法律明确规定不得限制的责任。
10.10  条款可分割性
若本章任何条款被有权机关认定无效或不可执行，不影响其他条款效力；双方仍应在合法范围内以最接近原意的有效条款替代。
第十一条  通知与送达
本协议项下通知可通过纸质信函、电子邮件、平台站内信发送。发送至本协议首页载明地址/邮箱，或乙方/甲方在平台预留联系方式的，于发送后24小时（电子邮件/站内信）或寄出后3日（快递）视为送达。
第十二条  争议解决
因本协议产生争议，双方应先友好协商；协商不成的，任何一方均可向甲方住所地有管辖权的人民法院提起诉讼。
因违约引起诉讼的，败诉方应承担胜诉方合理维权费用，包括诉讼费、保全费、律师费、公证费、差旅费、调查取证费等。
第十三条  其他
本协议附件与正文具有同等法律效力；正文与附件不一致的，以正文为准。
本协议未尽事宜，按平台公示规则及国家法律法规执行。
本协议一式两份，甲乙双方各执一份，具有同等法律效力。
附件目录
附件一：《平台入驻与类目管理规则》
附件二：《商品上架、审价与品质审核规则》
附件三：《技术服务费结算与对账规则》
附件四：《平台隐私政策与数据处理规则》

附件一：平台入驻与类目管理规则

制定主体：联采易（南京）科技有限公司
版本：V1.0    生效日期：______年______月______日
说明：本附件为《厂家入驻物业集采平台合作框架协议》的组成部分，与框架协议正文具有同等法律效力。

第一条  适用范围
本规则适用于拟入驻或已入驻联采易智物业集采平台（以下简称“平台”）的供应商（含厂家、品牌商及经平台认可的一级授权经销商）。
第二条  入驻条件
依法登记成立并有效存续，具备与拟经营品类相匹配的营业执照及行政许可（如需）。
具备对公银行账户，能够开具合法增值税发票。
具备稳定供货、售后及客服能力，同意遵守平台协议及本规则。
非被列入失信被执行人、重大税收违法或经营异常名录（平台可合理审查）。
源头厂家应提供生产或品牌原厂授权证明；经销商应提供有效授权链路。
第三条  入驻流程
在线提交入驻申请：企业基本信息、联系人、开户信息、经营类目等。
上传资质材料：营业执照、授权书、产品合格证明、其他平台要求文件。
平台审核：包括主体真实性、类目匹配度、合规性审查。
审核通过后开通供应商账号，进入商品维护与上架审核流程。
平台有权根据业务需要要求补充材料或实地核验。
第四条  类目准入与配额管理
4.1  供应商应按平台类目体系选择经营品类，不得超范围发布商品。
4.2  为维护平台生态与采购方利益，平台实行类目配额管理。原则上，同一细分品类（以平台类目编码及商品关键属性为准）的源头厂家数量不超过3家。
4.3  平台可在下列情形调整配额：
现有供应商履约不达标、投诉率或退款率异常；
采购方存在应急保供、区域独家或战略集采需求；
平台品类规划调整或新业务拓展；
供应商主动申请退出或平台终止合作。
第五条  账号与组织管理
供应商应指定管理员账号，并对子账号、操作人员权限负责。
账号仅限企业内部授权人员使用，不得出租、出借、转让。
企业信息、联系人、开户信息变更时，应及时在平台更新。
平台发现账号异常、冒用或违规操作的，有权限制或冻结账号功能。
第六条  暂停、退出与黑名单
供应商可申请退出平台，但须完成在途订单、技术服务费结算及售后义务。
存在严重违约、资质造假、重大质量事故、绕开平台交易等情形的，平台有权暂停或终止合作。
被终止合作的供应商及其关联企业，平台可列入黑名单并限制再次入驻。
第七条  规则更新
平台有权根据法律法规及业务需要修订本规则，并提前7日在平台公示。供应商继续使用平台服务的，视为接受修订；不同意的，可申请终止合作。

附件二：商品上架、审价与品质审核规则

制定主体：联采易（南京）科技有限公司
版本：V1.0    生效日期：______年______月______日
说明：本附件为《厂家入驻物业集采平台合作框架协议》的组成部分，与框架协议正文具有同等法律效力。

第一条  适用范围
本规则适用于供应商在平台发布、维护、上架及销售商品的全部活动。
第二条  上架基本原则
商品信息应真实、准确、完整，不得虚假宣传或误导采购方。
商品须符合国家强制性标准、行业标准及平台品类规范。
商品须同时通过“价格审核”和“品质/信息审核”后方可上架至商城。
上架后仍须持续满足库存、价格、资质及合规要求。
第三条  商品信息要求
基础信息：商品名称、SKU、类目、单位、规格、最小起订量等。
价格信息：不含税出厂价、运费、适用税率、发票类型（专票/普票）。
展示信息：主图、详情图、参数说明、专业档案（按品类要求填写）。
参考信息：1688零售价/批发价上限（如有），用于平台审价参考。
多规格商品：每个规格须单独维护价格、库存、运费及费率。
第四条  价格审核规则
4.1  定价公式
平台展示商品售价（不含税）= 供应商不含税出厂价 + 平台技术服务费（不含税）
订单销售价（含税）=（出厂价 + 运费 + 技术服务费）×（1 + 适用税率）
4.2  审价流程
新商品或价格变更提交后，进入“待价格审核”状态并自动下架。
平台运营人员审核出厂价、1688上限、成本/底价约束及合理性。
审核通过时，平台按商品或规格设定“平台服务费率”，系统据此计算商城销售价。
审核驳回的，供应商应根据驳回原因修改后重新提交。
对已审核通过的上架商品，平台有权发起“重新审价”。
4.3  审价约束
商城含税销售价不得高于1688参考上限（如已填写）。
销售价不得低于平台设定的成本价/底价约束。
服务费率默认参考平台统一配置，可在审价时按商品单独设定。
第五条  品质/信息审核规则
审核范围包括：商品名称、描述、类目、单位、图片、详情图、专业档案及资质信息。
新商品默认进入“待品质审核”；图文、参数、规格结构变更后重新进入待审并下架。
平台依据品类 checklist 审核信息完整性及合规性。
对已审核通过商品，平台有权发起“重新审质”。
第六条  上架、下架与强制处理
价格、品质双审通过后，由平台操作上架；供应商不得自行绕过审核直接销售。
供应商可申请下架；平台也可因违规、投诉、抽检不合格等原因强制下架。
存在待审、驳回、缺货预警未处理、重大投诉等情形的，平台可限制上架或展示。
第七条  发货与物流信息
平台执行“款到发货”：供应商确认收到采购方货款后方可发货。
发货后12小时内须录入真实物流信息（含快递、自送等方式）。
自送须如实填写车辆、司机、联系方式等信息。
虚假物流、延迟发货按平台规则及框架协议承担违约责任。
第八条  库存与缺货
供应商应及时维护库存数量。库存为0或不足时，商品仍可在商城展示并接受采购下单（可按起订量超库存预订）；供应商须在发货前备足货源。发货时系统按实际发货数量扣减库存，库存不足则无法完成发货。预计断供、停产或延迟交付的，应提前在平台预警，并及时与采购方协商。

附件三：技术服务费结算与对账规则

制定主体：联采易（南京）科技有限公司
版本：V1.0    生效日期：______年______月______日
说明：本附件为《厂家入驻物业集采平台合作框架协议》的组成部分，与框架协议正文具有同等法律效力。

第一条  适用范围
本规则适用于供应商通过平台完成交易后，向平台支付技术服务费的结算与对账。本规则仅规范技术服务费，不涉及采购方货款；货款由采购方直付供应商。
第二条  计费基础
技术服务费按平台审价确认的服务费率，基于商品不含税出厂价计算。
多规格商品按各规格分别计费；订单完成时以实际成交规格及数量为准。
计费基数以平台订单系统记录为准，包括出厂价、服务费率、数量等。
售价拆分明细（出厂价、运费、技术服务费）为双方商业秘密。
第三条  结算周期与统计口径
结算周期：每自然月为一个账期。
统计口径：以采购方“确认收货”的订单为准，计入对应自然月账期。
退货、退款、冲正订单按平台规则从当期或后续账期调整。
平台于每自然月结束后5个工作日内生成《月度技术服务费结算对账单》。
第四条  对账与异议
平台通过站内信、电子邮件或其他约定方式发送对账单。
供应商应在收到对账单后5个工作日内完成核对。
有异议的，应一次性书面说明理由并附证明材料；平台在10个工作日内复核回复。
逾期未提出异议且无合理说明的，视为认可对账单内容。
对账单争议期间，无争议部分仍应按期支付。
第五条  付款与发票
供应商应于收到对账单后、当月20日前（遇节假日顺延）支付上一自然月应付技术服务费总额。
结算金额：平台为小规模纳税人时，应付金额 = 审价技术服务费合计 M，付款与平台开具的增值税普通发票金额一致，不再另加税点。
平台在收到技术服务费后7个工作日内，向供应商开具等额合法发票（普票）。
供应商应向采购方就货款部分依法开具发票，与技术服务费发票相互独立。
第六条  逾期与违约
逾期支付超过10日的，平台有权下架商品、限制账户功能、暂停推荐或终止合作。
逾期违约金按每日万分之五计收，总额不超过应付未付金额的30%。
平台有权就应付技术服务费依法主张债权，但不冻结、划扣或保管采购方货款。
第七条  系统记录效力
平台系统生成的订单记录、收货记录、费率记录、对账单及操作日志，作为双方结算的主要依据。存在明显系统错误的，任一方可在异议期内申请更正。
第八条  终止后清算
合作终止不影响终止前已发生的技术服务费结算义务。供应商退出平台前，须结清全部应付技术服务费及在途订单相关费用。`,
  property_user_agreement: `物业公司入驻物业集采平台合作框架协议

甲方：联采易（南京）科技有限公司
统一社会信用代码：__________________________
住所地：____________________________________
联系人：______________  电话：______________  邮箱：______________

乙方：____________________________________
统一社会信用代码：__________________________
住所地：____________________________________
联系人：______________  电话：______________  邮箱：______________

鉴于甲方依法运营“联采易智”物业集采平台（以下简称“平台”），乙方拟以物业采购方身份入驻平台，通过平台向经平台审核的供应商（以下简称“供应商”）采购商品及服务。甲乙双方经平等协商，本着“资源共享、优势互补、合规采购、降本增效”的原则，就乙方入驻平台相关事宜，达成如下框架协议。本协议为框架性约定，具体操作规则以本协议正文及附件、平台公示规则为准。

第一条  定义与解释
“平台”：指由甲方开发、运营并提供技术服务的物业集采线上采购协同系统及相关配套功能。
“供应商”：指通过平台入驻、经甲方审核并向采购方供货的厂家、品牌商或经认可的一级授权经销商。
“采购方”/“乙方”：指本协议项下入驻平台并发起采购的物业公司及其授权用户。
“订单”/“电子订货单”：指乙方通过平台下单并经系统确认后自动生成的电子交易凭证。
“确认收货”：指乙方在平台点击确认收货，或物流信息显示已签收且超过平台规则约定的自动确认期限。
“付款凭证”：指乙方向供应商支付货款后，在平台上传的银行回单、转账截图或其他可证明付款的文件。
“企业管理员”：指乙方指定的、拥有本企业平台最高管理权限的首个注册账号持有人。
“关联企业”：指与乙方存在下列关系之一的企业：（1）一方持有另一方50%以上股权；（2）同受同一实际控制人控制；（3）法定代表人或主要负责人为同一人。
“绕开平台交易”：指乙方利用通过平台获得的供应商资源、商品信息、报价、联系方式或历史交易记录，通过平台以外渠道与供应商完成本可通过平台实现的交易，从而规避平台规则的行为。

第二条  合作模式与定位
2.1  合作定位
甲方为乙方提供商品浏览、全网比价、在线下单、审批协同、收货验收、付款登记、对账及沟通等数字化采购工具与交易撮合服务。甲方仅提供信息技术服务与交易撮合，不是乙方与供应商之间买卖合同的参与方，不参与商品生产、仓储、物流、质检、货款收付及发票开具的实际履行。
2.2  交易与资金模式
乙方通过平台向供应商下单，货款由乙方按订单约定直接支付至供应商指定对公账户，平台不代收、代付、保管或冻结货款。乙方应在平台登记付款凭证，供应商确认收款后安排发货。具体以平台公示规则及附件三为准。
2.3  平台服务
甲方可根据乙方使用情况提供采购数据分析、常购清单、审批流程配置、组织成员管理等功能；不保证特定供应商的供货能力、价格优势或订单必然成交。

第三条  入驻资质与审核
3.1  入驻材料
乙方应向甲方提交真实、完整、有效的营业执照、开户信息、联系人信息、物业相关资质（如需）及其他甲方要求的材料。乙方保证材料真实有效；因材料虚假导致的一切损失及法律责任由乙方承担。
3.2  入驻审核
甲方对乙方主体资格、经营范围与平台定位的匹配度进行审核。审核通过后，乙方取得平台采购方身份，并可指定企业管理员、邀请组织成员。甲方有权要求补充材料或实地核验。
3.3  账号与组织
企业管理员负责维护企业信息、邀请成员、分配角色权限、配置审批流程，对子账号操作承担管理责任。账号仅限企业内部授权人员使用，不得出租、出借、转让。具体以《物业企业入驻与组织管理规则》（附件一）为准。

第四条  采购、审批与订单
4.1  采购授权
乙方应建立内部采购管理制度，明确不同岗位（采购员、审批人、库管、财务等）的权限边界。采购人员仅在授权范围内发起采购；涉及审批的，须按企业配置的审批流程执行。
4.2  订单效力
乙方通过平台下单并经系统确认（含必要审批节点通过）后，自动生成的《电子订货单》对乙方与供应商具有约束力，订单总价为双方履行合同的主要依据。
4.3  审批模式
乙方可选择“平台内审批”或“线下审批登记”等模式（以平台功能及企业配置为准）。审批记录应真实、完整；不得伪造审批流程或绕过内控要求。
4.4  信息真实
乙方应保证提交的采购需求、收货地址、联系人、数量规格等信息真实、准确。因信息错误导致的延误、拒收或额外费用由乙方承担。

第五条  付款、收货与验收
5.1  付款义务
乙方应按电子订货单约定向供应商支付货款，并在平台上传真实、有效的付款凭证。平台展示付款状态主要用于交易协同，不对凭证真实性作实质性担保。
5.2  收货与验收
授权收货人员应在收到货物后及时验收，核对品名、规格、数量、质量等，并在平台确认收货或依法提出异议。确认收货或达到平台规则约定的自动确认条件，视为供应商完成交付义务。
5.3  售后与争议
退换货、质量异议、维修、赔偿等售后事项，由乙方与供应商依法处理；甲方可提供沟通协助，但不因此成为买卖关系当事人。

第六条  双方权利义务
6.1  甲方权利义务
（1）按本协议及平台规则提供系统服务，合理维护平台稳定运行；
（2）对供应商作形式准入审核，但不构成对供应商履约能力的担保；
（3）有权依据法律法规、平台规则对违规账户采取限制、暂停或终止服务等措施；
（4）依法保护乙方提交的企业信息及交易数据，详见《平台隐私政策与数据处理规则》。
6.2  乙方权利义务
（1）遵守国家法律法规、行业规范、本协议及平台公示规则；
（2）健全内部采购与财务制度，保障审批、付款、收货环节合规；
（3）对通过平台获知的供应商报价、成本信息、经营数据等承担保密义务；
（4）不得利用平台从事虚假交易、恶意下单、干扰定价或其他损害平台及供应商合法权益的行为；
（5）配合甲方依法开展的合规检查、纠纷协调及监管要求。

第七条  禁止绕开平台交易
7.1  乙方不得利用通过平台获取的供应商资源、商品链接、报价、联系方式或历史交易记录，诱导或协助供应商绕开平台完成交易。
7.2  下列情形除外：本协议生效前已存在且已向甲方报备的书面合同；法律法规、招标文件或乙方内部制度要求必须线下直采或招标的情形；不可抗力或应急保供且事后24小时内报备的情形。
7.3  乙方违反本条规定的，甲方有权限制账户功能、暂停服务、终止合作，并依法追究违约责任。

第八条  数据资产、个人信息与保密
8.1  平台系统运行过程中产生的用户行为数据、聚合分析数据及平台运营数据，其知识产权归甲方所有。
8.2  乙方提交的采购需求、订单、验收及付款登记数据，乙方对其原始内容享有合法权益；甲方有权为平台运营、对账、风控、分析及依法合规目的使用上述数据。
8.3  双方应遵守《个人信息保护法》等法律法规，对合作中获知的商业秘密承担保密义务。保密义务不因本协议终止而失效。

第九条  知识产权与合规
9.1  乙方保证其在平台录入、上传的信息不侵犯第三方合法权益。
9.2  乙方不得实施商业贿赂、围标串标、虚假采购、侵占供应商合法权益等违法行为。违反法律法规或平台规则的，甲方有权立即终止合作。

第十条  协议期限、变更与退出
10.1  合作期限
本协议有效期2年，自乙方在线确认同意并完成入驻审核之日起生效。期满前30日，任何一方未书面提出不续约通知的，自动顺延1年，以后亦同。
10.2  规则变更
甲方有权根据业务需要调整平台规则，涉及乙方核心权利义务的重大变更，应提前7日在平台公示。乙方继续使用平台服务的，视为接受变更；不同意变更的，可申请终止合作。
10.3  退出与解除
任一方拟终止合作的，应提前30日书面通知对方（或通过平台指定流程申请）。乙方有下列情形之一，甲方有权单方解除协议且不承担赔偿责任：
（1）提交虚假资质或伪造审批、付款、收货记录；
（2）严重绕开平台交易或协助供应商绕开平台；
（3）恶意下单、恶意拒收或严重损害平台声誉；
（4）严重违法违规或违反保密及数据合规义务。
10.4  终止后清算
协议终止不影响终止前已产生权利义务。终止前已确认订单，乙方仍须完成付款（如未付）、收货验收、售后配合等义务。

第十一条  免责与责任限制
11.1  平台法律地位
甲方仅为信息技术服务与交易撮合方，不对供应商产品质量、交付能力、持续供货、发票合规及货款安全承担担保责任。平台责任边界亦见《平台免责声明》。
11.2  责任限制
在法律允许的最大范围内，甲方对间接损失、预期利润损失等不承担责任；甲方因本协议向乙方承担的全部赔偿责任，累计不超过争议发生前12个月内乙方向甲方实际支付的平台服务费用总额（如无则以前述期间为限且以人民币一万元为上限）。

第十二条  通知与送达
本协议项下通知可通过纸质信函、电子邮件、平台站内信发送。发送至本协议首页载明地址/邮箱，或乙方/甲方在平台预留联系方式的，于发送后24小时（电子邮件/站内信）或寄出后3日（快递）视为送达。

第十三条  争议解决
因本协议产生争议，双方应先友好协商；协商不成的，任何一方均可向甲方住所地有管辖权的人民法院提起诉讼。

附件目录
附件一：《物业企业入驻与组织管理规则》
附件二：《采购审批与订单管理规则》
附件三：《收货验收、付款登记与对账规则》

（以下无正文，为签署页）

甲方（盖章）：____________________
授权代表（签字）：________________
日期：______年______月______日

乙方（盖章）：____________________
授权代表（签字）：________________
日期：______年______月______日

附件一：物业企业入驻与组织管理规则

制定主体：联采易（南京）科技有限公司
版本：V1.0
说明：本附件为《物业公司入驻物业集采平台合作框架协议》的组成部分，与框架协议正文具有同等法律效力。

第一条  适用范围
本规则适用于拟入驻或已入驻联采易智物业集采平台（以下简称“平台”）的物业采购方企业。

第二条  入驻条件
2.1  依法登记成立并有效存续，具备合法经营资格。
2.2  具备对公银行账户，能够配合完成采购付款及财务对账。
2.3  具备内部采购管理制度及至少一名企业管理员，同意遵守平台协议及本规则。
2.4  非被列入失信被执行人、重大税收违法或经营异常名录（平台可合理审查）。

第三条  入驻流程
3.1  在线提交入驻申请：企业名称、统一社会信用代码、联系人、开户信息等。
3.2  上传资质材料：营业执照、物业相关资质（如需）、其他平台要求文件。
3.3  平台审核主体真实性及合规性。
3.4  审核通过后开通企业管理员账号，进入组织成员邀请与审批配置流程。

第四条  组织与账号管理
4.1  企业管理员可邀请采购员、审批人、库管、财务等成员，并分配角色权限。
4.2  成员账号仅限企业内部授权人员使用，不得出租、出借、转让。
4.3  企业信息、联系人、开户信息变更时，应及时在平台更新。
4.4  平台发现账号异常、冒用或违规操作的，有权限制或冻结账号功能。

第五条  暂停、退出与黑名单
5.1  乙方可申请退出平台，但须完成在途订单、付款登记及售后配合义务。
5.2  存在严重违约、资质造假、绕开平台交易等情形的，平台有权暂停或终止合作。
5.3  被终止合作的物业企业及其关联企业，平台可列入限制名单。

第六条  规则更新
平台有权根据法律法规及业务需要修订本规则，并提前7日在平台公示。

附件二：采购审批与订单管理规则

制定主体：联采易（南京）科技有限公司
版本：V1.0
说明：本附件为《物业公司入驻物业集采平台合作框架协议》的组成部分，与框架协议正文具有同等法律效力。

第一条  适用范围
本规则适用于物业采购方在平台发起采购、审批、变更及取消订单的全部活动。

第二条  采购基本原则
2.1  采购需求应真实、合规，符合企业内部管理制度及预算要求。
2.2  商品选择应基于平台公示信息，重大采购应履行必要审批程序。
2.3  不得利用平台从事虚假交易、刷单或干扰市场秩序的行为。

第三条  审批流程配置
3.1  企业管理员可在平台配置审批节点、金额阈值、审批角色及审批模式。
3.2  “平台内审批”模式下，订单须按配置流程逐级通过后生效。
3.3  “线下审批登记”模式下，采购员应如实登记线下已完成的审批结果，企业对登记真实性负责。
3.4  审批人员应在职责范围内及时审批，并对审批意见负责。

第四条  下单与订单变更
4.1  采购员在授权范围内选择商品、规格、数量并提交订单。
4.2  订单经系统确认（及必要审批通过）后，对采购方与供应商具有约束力。
4.3  订单变更或取消应依据平台功能及双方约定执行；已进入履约阶段的，应依法协商处理。

第五条  价格与信息
5.1  平台展示价格为供应商报价经平台规则处理后的商城销售价，采购方下单时以系统确认价格为准。
5.2  采购方应知悉：售价拆分明细（产品价、运费、平台技术服务费等）属于平台与供应商之间的商业秘密，除依法披露外不得非法获取或外泄。

第六条  记录与审计
平台保留订单、审批、操作日志等记录，供企业内部管理及合规审计参考。

附件三：收货验收、付款登记与对账规则

制定主体：联采易（南京）科技有限公司
版本：V1.0
说明：本附件为《物业公司入驻物业集采平台合作框架协议》的组成部分，与框架协议正文具有同等法律效力。

第一条  适用范围
本规则适用于物业采购方通过平台完成的收货验收、付款凭证登记及对账协同活动。

第二条  付款登记
2.1  采购方应按订单约定向供应商指定对公账户支付货款。
2.2  付款后应在平台上传真实、有效的付款凭证，并确保金额、日期、收款方与订单一致。
2.3  平台展示付款状态主要用于交易协同，不对凭证真实性作实质性审查或担保。

第三条  发货与收货
3.1  供应商在确认收到货款后安排发货（特殊品类另有约定的除外）。
3.2  采购方应指定有效收货地址及收货联系人。
3.3  授权收货人员收到货物后应及时验收，并在平台确认收货或提出异议。

第四条  验收标准
4.1  验收包括品名、规格、数量、外观、包装及必要质量检查。
4.2  发现短缺、破损、规格不符或质量问题的，应在合理期限内提出并依法处理。
4.3  确认收货或达到自动确认条件的，视为供应商完成交付义务。

第五条  对账协同
5.1  平台提供订单、付款、收货状态等数据供采购方内部对账使用。
5.2  采购方与供应商之间的货款、发票争议，由双方依法解决；平台可提供必要协助。

第六条  售后配合
退换货、质量异议等售后事项，由采购方与供应商依法处理。采购方应配合在平台更新必要状态，便于交易闭环。`,
  platform_user_agreement: `平台用户服务协议

制定主体：联采易（南京）科技有限公司
版本：V1.0

第一条  适用范围
本协议适用于受物业企业或平台邀请、注册并使用联采易智物业集采平台账号的自然人用户（含采购员、审批人、库管、财务及其他授权岗位）。

第二条  账号使用
2.1  用户账号由所属企业管理员创建或邀请开通，用户应在授权范围内使用平台功能。
2.2  用户应使用真实身份信息，妥善保管账号、密码及验证码，不得转借他人。
2.3  用户对账号下的操作行为负责，包括下单、审批、收货确认、信息录入等。

第三条  服务内容与权限
3.1  平台根据企业分配的角色，向用户提供相应的采购、审批、仓储、财务协同等功能。
3.2  用户不得越权访问、修改或导出未经授权的数据。
3.3  平台有权根据安全及合规需要调整功能权限。

第四条  用户义务
4.1  遵守国家法律法规、所属企业内部制度及平台规则。
4.2  保证录入信息真实、准确、完整，不得伪造审批记录或交易凭证。
4.3  不得利用平台从事欺诈、泄露商业秘密、干扰系统运行等行为。

第五条  信息与隐私
5.1  平台依法收集和使用用户手机号、姓名、操作日志等必要信息，用于身份验证、权限控制、审计及客户服务。
5.2  用户享有依法查询、更正个人信息等权利，详见《平台隐私政策与数据处理规则》。
5.3  用户对工作中接触的企业数据、供应商信息、价格信息等承担保密义务。

第六条  知识产权
平台软件、界面、文档及运营内容的知识产权归平台所有。未经授权，不得复制、传播或用于商业用途。

第七条  责任限制
7.1  平台按“现状”提供技术服务，不对因用户误操作、账号泄露、设备故障等用户自身原因导致的损失承担责任。
7.2  因所属企业与供应商之间的交易争议，由相关主体依法解决，平台可提供必要协助。

第八条  违规处理
用户违反本协议或平台规则的，所属企业及平台有权采取警告、限制权限、停用账号等措施；造成损失的，依法承担相应责任。

第九条  协议更新
平台更新本协议后将提前公示。用户继续使用服务的，视为接受更新后的协议。

第十条  争议解决
因本协议产生争议，先协商解决；协商不成的，提交平台运营方住所地有管辖权的人民法院诉讼解决。

第十一条  联系我们
如有疑问，请通过平台公示的客服渠道联系联采易（南京）科技有限公司。`,
};

export function getLegalDocumentFallbackContent(slug: string): string | null {
  return LEGAL_DOCUMENT_FULL_CONTENT[slug] ?? null;
}
